module.exports = __webpack_public_path__ + "static/media/defaultPic.d7bd690d.png";